import React from "react";

export default function Footer() {
  return (
    <p>
      <a
        className="openSource"
        href="https://github.com/shamsayara/weather-react"
        target="blank"
      >
        {" "}
        Open-source code{" "}
      </a>{" "}
      by Yara Shamsah
    </p>
  );
}
